import { intervalToDuration } from 'date-fns'

import { DurationFormatter } from '@blade/ui-kit'
import { useDateFnsLocale, useTranslation } from '@root/shared/localization'

import type { CurrencyModel } from '@root/entities/currency'

export const useCurrencyExpirationLeft = () => {
  const { t } = useTranslation()
  const locale = useDateFnsLocale()
  return {
    formatExpirationLeft: (
      currency: CurrencyModel,
      expiresAt: Date | undefined,
    ) => {
      if (!expiresAt) {
        return undefined
      }
      const now = new Date()
      if (now > expiresAt) {
        return undefined
      }
      const formatted = DurationFormatter.formatDurationSingleUnit(
        intervalToDuration({ start: now, end: expiresAt }),
        { locale: locale },
      )
      if (!formatted) {
        return undefined
      }

      return t('common.n-left', { n: formatted })
    },
  }
}
